const DefaultValues = {
    Address: {
        Address: "",
        Zip: "",
        LatLng: {},
        Street: "",
        City: ""
    },
    Roof: {
        Type: "Flachdach",
        Zones: [],
        Obstacles: []
    },
    SkipRoof: false,
    ConstructionYear: null,
    RoofType: "Flachdach",
    EmergencyPower: "Nein",
    AnnualConsumption: 3500,
    Energycost: 30,
    EnergycostTwentyYearIncrease: 3,
    EnergyCompensation: 7.6,
    // these default values should initialize the heatpump form
    // instead they are always set
    EnergyRenovation: "Nein",
    UsableSquareMeter: 120,
    HeatingPumpConsumption: 4200,
    RenovationYear: null,
    PersonsInHousehold: 3,
    Cars: [],
    FachpartnerId: null,
    SelectedPartner: null,
    ContinueWithoutPartner: false
}

export default DefaultValues;